@if (!accessAllowed)
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <h4 class="mt-2"><i class="fa-solid fa-octagon-exclamation"></i> Adgang kun tilladt for administratorer!</h4>
</div>
}
@else {
<div class="card h-100 card-no-border mt-4">
    <div class="card-body no-padding">
        <cfg-table [resource]="assignmentsResource" [rows]="assignments()" [columns]="columns" [trackBy]="trackById"
            [searchFields]="['customerId', 'name', 'departmentCode', 'departmentName']" searchParam="search"
            [defaultSort]="{ key: 'customerId', direction: 'desc' }"
            searchPlaceholder="Søg kunder..." emptyText="Ingen kunder at vise." loadingText="Indlæser kunder..."
            errorText="Fejl under indlæsning af kunder.">

            <div cfgToolbar class="d-flex align-items-center gap-2">
                <select class="form-select form-select-sm w-auto" aria-label="Filtrér på database"
                    [ngModel]="databaseFilter()" (ngModelChange)="databaseFilter.set($event)">
                    <option value="all">Har database: Alle</option>
                    <option value="yes">Har database: Ja</option>
                    <option value="no">Har database: Nej</option>
                </select>
                <select class="form-select form-select-sm w-auto" aria-label="Filtrér på aktive synkroniseringer"
                    [ngModel]="syncFilter()" (ngModelChange)="syncFilter.set($event)">
                    <option value="all">Har synk.: Alle</option>
                    <option value="yes">Har synk.: Ja</option>
                    <option value="no">Har synk.: Nej</option>
                </select>
            </div>

            <ng-template cfgCell="hasDatabase" [cfgCellOf]="assignments()" let-row>
                @if (row.hasDatabase)
                {
                <i title="Kunden har en tenant-database i dette miljø" class="fa-solid fa-check fa-lg" aria-hidden="true"></i>
                <span class="visually-hidden">Har database</span>
                }
            </ng-template>

            <ng-template cfgCell="department" [cfgCellOf]="assignments()" let-row>
                <select class="form-select" placeholder="afdeling"
                    [disabled]="isSaving(row) || row.readonly"
                    [(ngModel)]="row.departmentId"
                    (ngModelChange)="onDepartmentChange(row)">
                    <option [value]="null">-- Vælg afdeling --</option>
                    @for (option of departments(); track option.id)
                    {
                    <option [value]="option.id">
                        {{ option.code === emptyGuid ? option.name : option.name + ' [' + option.code + ']' }}
                    </option>
                    }
                </select>
            </ng-template>

            <ng-template cfgCell="active" [cfgCellOf]="assignments()" let-row>
                <input type="checkbox" class="form-check-input"
                    [(ngModel)]="row.active"
                    (ngModelChange)="onActiveChange(row)"
                    [disabled]="isSaving(row) || row.readonly">
            </ng-template>

            <ng-template cfgCell="hasSynchronizations" [cfgCellOf]="assignments()" let-row>
                @if (row.readonly)
                {
                <i title="Kunden har aktive synkroniseringer" class="fa-solid fa-check fa-lg" aria-hidden="true"></i>
                <span class="visually-hidden">Har aktive synkroniseringer</span>
                }
            </ng-template>

            <ng-template cfgCell="status" [cfgCellOf]="assignments()" let-row>
                @if(isSaving(row))
                {
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Gemmer...</span>
                </div>
                }
            </ng-template>

            <ng-template cfgCell="actions" [cfgCellOf]="assignments()" let-row>
                <!-- container="body": tabellen scroller, ellers klippes menuen af table-wrap'en -->
                <div ngbDropdown container="body" placement="bottom-end">
                    <button type="button" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle
                        [attr.aria-label]="'Genveje for ' + row.name">
                        <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                    </button>
                    <div ngbDropdownMenu>
                        <button type="button" ngbDropdownItem (click)="openCustomer(row)"
                            [disabled]="!row.hasDatabase"
                            [title]="row.hasDatabase ? '' : 'Kunden har ingen database i dette miljø og kan ikke åbnes'">
                            Rediger kunde
                        </button>
                        <button type="button" ngbDropdownItem (click)="openTemplates(row)"
                            [disabled]="!row.departmentId"
                            [title]="row.departmentId ? '' : 'Kunden er ikke tildelt en afdeling'">
                            Skabeloner
                        </button>
                        <button type="button" ngbDropdownItem (click)="openSynchronizations(row)">
                            Synkroniseringer
                        </button>
                    </div>
                </div>
            </ng-template>
        </cfg-table>
    </div>
</div>
}
